"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategy = void 0;
const erc721_abi_1 = require("../../abi/erc721.abi");
const required_1 = require("../../helpers/required/required");
const web3Factory_1 = require("../helpers/web3Factory");
const lodash_1 = require("lodash");
const getSymbolAndName_1 = require("../helpers/getSymbolAndName");
const messageHelper_1 = require("../helpers/messageHelper");
const web3_1 = __importDefault(require("web3"));
const sumBN_1 = require("../helpers/sumBN/sumBN");
const getBalanceOfIssuedBy = (params, issuer, addresses) => __awaiter(void 0, void 0, void 0, function* () {
    const { address: ERC71Address, chainId } = params;
    required_1.requiredDefined(ERC71Address, 'address of token is required');
    required_1.requiredDefined(chainId, 'chainId of token is required');
    required_1.requiredDefined(issuer, 'chainId of token is required');
    required_1.requiredType(addresses, 'array', 'addresses must be defined');
    const web3Provider = yield web3Factory_1.web3Factory(chainId);
    const erc721SmartContracts = new web3Provider.eth.Contract(erc721_abi_1.erc721ABI, ERC71Address);
    const result = yield Promise.all(addresses.map((walletAddress) => __awaiter(void 0, void 0, void 0, function* () {
        const numberOfTokens = yield erc721SmartContracts.methods.balanceOf(walletAddress).call();
        const tokensOwnerIssuedby = yield Promise.all(lodash_1.range(numberOfTokens)
            .map((tokenIndex) => __awaiter(void 0, void 0, void 0, function* () {
            const tokenId = yield erc721SmartContracts.methods.tokenOfOwnerByIndex(walletAddress, tokenIndex).call();
            const tokenIssuer = yield erc721SmartContracts.methods.issuerOf(tokenId).call();
            return tokenIssuer.toLowerCase() === issuer.toLowerCase();
        })));
        return {
            chainId,
            address: walletAddress,
            balanceOf: tokensOwnerIssuedby.filter(d => d).length.toString()
        };
    })));
    return lodash_1.flattenDeep(result);
});
const getBalances = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const { tokens } = strategy.params;
    const balances = yield Promise.all(tokens.map(token => getBalanceOfIssuedBy(token, strategy.params.issuer, strategy.addresses)));
    const flatBalances = lodash_1.flattenDeep(balances);
    const sum = sumBN_1.sumBN(flatBalances.map(d => d.balanceOf));
    return {
        balances,
        sum
    };
});
exports.strategy = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const { params } = strategy;
    const firstToken = params.tokens[0];
    let symbol, name;
    if (params.name && params.symbol) {
        symbol = params.symbol;
        name = params.name;
    }
    else {
        const result = yield getSymbolAndName_1.getNameAndSymbolERC721({
            address: firstToken.address,
            chainId: firstToken.chainId,
            default: {
                name: params.name,
                symbol: params.symbol
            }
        });
        symbol = result.symbol;
        name = result.name;
    }
    const balances = yield getBalances(strategy);
    const amount = web3_1.default.utils.toBN(balances.sum);
    const minAmount = web3_1.default.utils.toBN(params.minBalance);
    const isAuthorized = amount.gte(minAmount);
    const message = messageHelper_1.minMaxMessage({
        symbol,
        name,
        decimals: 0,
        balance: balances.sum,
        amountRequired: params.minBalance
    });
    const code = isAuthorized ? 0 /* SUCCESS */ : 1 /* NOTENOUGH */;
    const enrichedInformations = {
        symbol: symbol,
        name: name,
        logo: strategy.logo,
        acquireURLs: strategy.acquireURLs
    };
    return {
        isAuthorized,
        strategy: strategy,
        message: message,
        code,
        enrichedInformations,
        details: balances
    };
});
//# sourceMappingURL=index.js.map